import React from 'react';
import { cn } from '@bem-react/classname';

import { useNavigate } from 'react-router-dom';
import { gallery_list } from '@config/gallery-list-config';
import { YAText } from '@ui-kit';
import { GalleryIDEnum } from '@models/gallery-list';

import './GalleryList.style.scss';
import { Header } from '@components/Header';

const CnGalleryList = cn('gallery-list');

const GalleryList = () => {
  const navigate = useNavigate();
  const onItemClick = (id: GalleryIDEnum) => {
    navigate(`/gallery/${id}`);
  };

  return (
    <div className={CnGalleryList()}>
      <Header />
      <div className={CnGalleryList('content')}>
        {gallery_list.map((item, index) => (
          <div
            key={`${item.id}`}
            className={CnGalleryList('content-item')}
            onClick={() => onItemClick(item.id)}
          >
            <YAText className={CnGalleryList('content-item-text')} text={item.name} type={'H2'} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default GalleryList;
